import ItemSkeleton from './Item/Skeleton'

export default function CartItemsSkeleton() {
  return (
    <div className="flex flex-col divide-y divide-solid px-3 overflow-auto">
      <ItemSkeleton />
    </div>
  )
}
